import { SaveDataKeys } from '../core/managers/SaveDataKeys';
import { PlayerID } from '../utils/GameEngine';
import { CoreController } from '../core/CoreController';
import gameanalytics = require('gameanalytics');

export enum ResourceAquireType {
    BuyForCoins = 'BuyForCoins',
    BuyForAd = 'BuyForAd',
    GameReward = 'GameReward'
}

export class GameAnalytics {
    private static _instance: GameAnalytics;
    private tester: boolean = false;
    private testerEvents: string[] = [];

    private constructor() {
        const testerIDs: PlayerID[] = ['3476655469120693', '3856037791096114', '4687385071303435', '3273819176062144'];
        const myID: PlayerID = FBInstant.player.getID();
        if (testerIDs.indexOf(myID) > -1) {
            this.tester = true;
            console.log('TESTER ID: ' + myID);
        }
        gameanalytics.GameAnalytics.initialize(
            '9f35267f047190e6ff55642064141f49',
            '70c4a2eab9f1c21d9bb8487bdbe89aa05d171ff4'
        );
    }

    public static getInstance(): GameAnalytics {
        return this._instance || (this._instance = new this());
    }

    public isTester(): boolean {
        return this.tester;
    }

    public logProgression(
        eventName: any,
        score?: number
    ): void {
        const chapter: number = CoreController.getInstance().getCurrentChapter();
        const level: number = CoreController.getInstance().getCurrentLevel();
        gameanalytics.GameAnalytics.addProgressionEvent(eventName, 'chapter_' + chapter, 'level_' + level, null, score);
    }

    public logDesign(
        eventName: any,
        perChapter: boolean = false,
        perLevel: boolean = false,
        value?: number,
        additionalDimension?: string
    ): void {
        if (perChapter) {
            const chapter: number = CoreController.getInstance().getCurrentChapter();
            eventName += ':' + 'chapter_' + chapter;
        }
        if (perLevel) {
            const level: number = CoreController.getInstance().getCurrentLevel();
            eventName += ':' + 'level_' + level;
        }
        if (additionalDimension) {
            eventName += ':' + additionalDimension;
        }
        gameanalytics.GameAnalytics.addDesignEvent(eventName, value);
    }

    public async logEventTester(
        eventName: string,
        valueToSum?: number,
        parameters?: any,
        perChapter: boolean = false,
        perLevel: boolean = false
    ): Promise<void> {
        await this.getTesterEvents();
        if (this.tester && this.testerEvents.indexOf(eventName) > -1) {
            console.log(eventName + ' was not sent because user is a tester and event was already sent!');
            return;
        }
        this.updateTesterEvents(eventName);
        this.doLog(eventName, valueToSum, parameters, perChapter, perLevel);
    }

    private async doLog(
        eventName: string,
        valueToSum?: number,
        parameters?: any,
        perChapter: boolean = false,
        perLevel: boolean = false
    ): Promise<void> {
        console.log(eventName + ' sent!');
        if (perChapter || perLevel) {
            if (!parameters) {
                parameters = {};
            }
            if (perChapter) {
                const chapter: number = CoreController.getInstance().getCurrentChapter();
                parameters.chapter = chapter;
            }

            if (perLevel) {
                const level: number = CoreController.getInstance().getCurrentLevel();
                parameters.level = level;
            }
        }
        return FBInstant.logEvent(
            eventName,
            valueToSum,
            parameters
        );
    }

    private async getTesterEvents(): Promise<void> {
        return FBInstant.player
            .getDataAsync([SaveDataKeys.testerEvents]).then((data: string[]): void => {
                this.testerEvents = data[SaveDataKeys.testerEvents] || [];
            });
    }

    private async updateTesterEvents(eventName: string): Promise<void> {
        if (this.tester) {
            this.testerEvents.push(eventName);
            FBInstant.player
                .setDataAsync({testerEvents: this.testerEvents}).then((): void => {
                console.log('Updated tester events with event: ' + eventName);
            });
        }
    }
}